"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayersDrawer = LayersDrawer;
exports.layersDrawerWidth = exports.defaultBaseLayers = exports.baseLayersThumbnails = void 0;
var _Drawer2 = _interopRequireDefault(require("@mui/material/Drawer"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _InfoOutlined2 = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _Switch2 = _interopRequireDefault(require("@mui/material/Switch"));
var _ExploreOutlined2 = _interopRequireDefault(require("@mui/icons-material/ExploreOutlined"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Toolbar2 = _interopRequireDefault(require("@mui/material/Toolbar"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _aerial = _interopRequireDefault(require("../../assets/images/layers/aerial.jpeg"));
var _dark = _interopRequireDefault(require("../../assets/images/layers/dark.png"));
var _geovelo = _interopRequireDefault(require("../../assets/images/layers/geovelo.png"));
var _ign = _interopRequireDefault(require("../../assets/images/layers/ign.jpeg"));
var _accueilVelo = _interopRequireDefault(require("../../assets/images/poi/accueil-velo.png"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _icons = require("../icons");
var _facilitiesLegend = require("./facilities-legend");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const layersDrawerWidth = exports.layersDrawerWidth = 320;
const baseLayersThumbnails = exports.baseLayersThumbnails = {
  geovelo: _geovelo.default,
  aerial: _aerial.default,
  ign: _ign.default,
  dark: _dark.default
};
const defaultBaseLayers = exports.defaultBaseLayers = ['geovelo', 'aerial', 'ign'];
const categoriesDisabled = ['bicycleHome', 'tourismOffice'];
const lavCategoriesNotBicycleHome = ['lavLocalProducts', 'lavPackedLunch', 'lavBicycleStopingArea'];
function LayersDrawer({
  smallDevice,
  baseLayer,
  disableLayerSelection,
  disableParkings,
  facilitiesShowed,
  widgetConfig,
  layers,
  layersShowed,
  enableFacilitiesToggle,
  enableHillshadesToggle,
  hillshadesShowed,
  enableHeatmapToggle,
  heatmapShowed,
  loadingHeatmap,
  poiOptions,
  enableReportsToggle,
  reportsShowed,
  poiCategories,
  selectedPoiCategories,
  onBaseLayerChange,
  toggleFacilities,
  toggleLayers,
  toggleHillshades,
  toggleHeatmap,
  setPoiOptions,
  toggleReports,
  selectPoiCategories,
  onClose,
  ...props
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  function handlePoiCategoryToggle({
    code,
    parentCode,
    children
  }, _selected) {
    const selected = _selected !== undefined ? _selected : !selectedPoiCategories[code];
    const _selectedPoiCategories = {
      ...selectedPoiCategories,
      [code]: selected
    };
    children.forEach(({
      code
    }) => _selectedPoiCategories[code] = selected);
    if (parentCode) {
      const parent = poiCategories?.find(({
        code
      }) => code === parentCode);
      if (selected) {
        if (parent && parent.children.every(({
          code
        }) => _selectedPoiCategories[code] === true)) _selectedPoiCategories[parentCode] = true;
      } else _selectedPoiCategories[parentCode] = false;
    }
    try {
      localStorage.setItem('poi_categories', _models.poiCategoryCodes.filter(code => _selectedPoiCategories[code]).join(','));
    } catch {
      console.error('localStorage access is denied');
    }
    selectPoiCategories(_selectedPoiCategories);
  }
  return /*#__PURE__*/_react.default.createElement(StyledDrawer, _extends({
    anchor: "left",
    className: smallDevice ? 'full-width' : '',
    variant: "persistent"
  }, props), /*#__PURE__*/_react.default.createElement(_Toolbar2.default, {
    sx: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'center',
      paddingX: 5,
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600,
    variant: "subtitle1"
  }, t('commons.layers_drawer.title')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    height: "100%",
    position: "absolute",
    right: 8,
    top: 0
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null))))), /*#__PURE__*/_react.default.createElement(_Divider2.default, null), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    paddingY: 2,
    sx: {
      overflowY: 'auto'
    }
  }, !disableLayerSelection && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    paddingX: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, t('commons.layers_drawer.baselayer').toUpperCase()), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    gap: 2
  }, defaultBaseLayers.map(key => {
    const active = key === baseLayer;
    return /*#__PURE__*/_react.default.createElement(_Box2.default, {
      display: "flex",
      flexDirection: "column",
      gap: 1,
      key: key,
      width: `calc((100% - ${(defaultBaseLayers.length - 1) * 16}px) / ${defaultBaseLayers.length})`
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignSelf: "stretch",
      borderRadius: 2,
      component: active ? 'div' : _ButtonBase2.default,
      height: active ? 64 : 68,
      onClick: () => !active && onBaseLayerChange?.(key),
      sx: ({
        palette
      }) => ({
        backgroundImage: `url(${baseLayersThumbnails[key]})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        border: `2px solid ${active ? palette.primary.main : 'transparent'}`
      })
    }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "caption"
    }, t(_hooks.baseLayersMap[key].labelKey || '')));
  }))), /*#__PURE__*/_react.default.createElement(_Divider2.default, null)), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    paddingX: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, t('commons.layers_drawer.details').toUpperCase())), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    sx: {
      'fieldset:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      }
    }
  }, enableFacilitiesToggle && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    color: "#03966a",
    Icon: _icons.BikeIcon,
    info: /*#__PURE__*/_react.default.createElement(_facilitiesLegend.FacilitiesLegend, {
      enableDescriptions: true,
      layers: layers
    }),
    label: t('commons.facilities_label'),
    onChange: enabled => {
      try {
        localStorage.setItem('display_facilities', enabled ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      toggleFacilities?.(enabled);
    },
    value: facilitiesShowed || false
  }), widgetConfig?.code === 'larochelle' && layers?.[0] && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    label: layers[0].name,
    onChange: enabled => toggleLayers?.(enabled),
    value: layersShowed || false
  }), enableReportsToggle && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    color: "#ee7734",
    Icon: _icons.RoadworksIcon,
    label: t('commons.reports_label'),
    onChange: enabled => {
      try {
        localStorage.setItem('display_reports', enabled ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      toggleReports?.(enabled);
    },
    value: reportsShowed || false
  }), enableHillshadesToggle && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    color: "#212121",
    Icon: _icons.VerticalGainIcon,
    label: t('commons.hillshades_label'),
    onChange: enabled => {
      try {
        localStorage.setItem('display_hillshades', enabled ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      toggleHillshades?.(enabled);
    },
    value: hillshadesShowed || false
  }), enableHeatmapToggle && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    color: "rgb(73, 116, 165)",
    disabled: loadingHeatmap,
    Icon: _ExploreOutlined2.default,
    label: t('commons.heatmap_label'),
    onChange: enabled => {
      toggleHeatmap?.(enabled);
    },
    value: heatmapShowed || false
  }), !disableParkings && !poiCategories?.find(({
    code
  }) => code === 'bicycleParking') && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    color: "#326ac2",
    Icon: _icons.ParkingIcon,
    label: t('commons.poi.categories.parking_other'),
    onChange: enabled => {
      try {
        localStorage.setItem('display_parking_spaces', enabled ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      setPoiOptions?.({
        ...poiOptions,
        displayParkingSpaces: enabled
      });
    },
    value: poiOptions?.displayParkingSpaces || false
  }))), widgetConfig?.code === 'lav' && /*#__PURE__*/_react.default.createElement(SwitchControl, {
    icon: _accueilVelo.default,
    info: t('commons.poi.bicycle_home_restriction'),
    label: t('commons.poi.categories.lav_bicycle_home'),
    onChange: enabled => {
      try {
        localStorage.setItem('display_only_bicycle_home', enabled ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      setPoiOptions?.({
        ...poiOptions,
        displayOnlyBicycleHome: enabled
      });
    },
    value: poiOptions?.displayOnlyBicycleHome || false
  }), poiCategories?.filter(({
    parentCode
  }) => parentCode === null).sort((a, b) => a.order - b.order).map(category => {
    const {
      id,
      code,
      labelKey,
      color,
      icon
    } = category;
    const children = poiCategories.filter(({
      code: childCode,
      parentCode
    }) => parentCode === code && !categoriesDisabled.includes(childCode) && (widgetConfig?.code !== 'lav' || !poiOptions?.displayOnlyBicycleHome || !lavCategoriesNotBicycleHome.includes(childCode)));
    return /*#__PURE__*/_react.default.createElement(_Box2.default, {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      paddingX: 2
    }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      color: "textSecondary",
      variant: "caption"
    }, t(`${labelKey}_other`).toUpperCase())), /*#__PURE__*/_react.default.createElement(_Box2.default, {
      display: "flex",
      flexDirection: "column",
      sx: {
        'fieldset:not(:last-child)': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
      }
    }, children.length === 0 ? /*#__PURE__*/_react.default.createElement(SwitchControl, {
      color: color || '',
      icon: icon,
      label: t(`${labelKey}_other`),
      onChange: () => handlePoiCategoryToggle(category),
      value: selectedPoiCategories[code] || false
    }) : children.sort((a, b) => a.order - b.order).map(childCategory => {
      const {
        id: childId,
        code: childCode,
        labelKey: childLabelKey,
        color: childColor,
        icon: childIcon
      } = childCategory;
      if (childCode === 'bicycleParking') {
        return !disableParkings && /*#__PURE__*/_react.default.createElement(SwitchControl, {
          color: "#326ac2",
          Icon: _icons.ParkingIcon,
          key: childId,
          label: t('commons.poi.categories.parking_other'),
          onChange: enabled => {
            try {
              localStorage.setItem('display_parking_spaces', enabled ? 'true' : 'false');
            } catch {
              console.error('localStorage access is denied');
            }
            setPoiOptions?.({
              ...poiOptions,
              displayParkingSpaces: enabled
            });
          },
          value: poiOptions?.displayParkingSpaces || false
        });
      }
      return /*#__PURE__*/_react.default.createElement(SwitchControl, {
        color: childColor || color || '',
        icon: childIcon,
        key: childId,
        label: t(`${childLabelKey}_other`),
        onChange: () => handlePoiCategoryToggle(childCategory),
        value: selectedPoiCategories[childCode] || false
      });
    })));
  })));
}
function SwitchControl({
  disabled,
  value,
  Icon,
  icon,
  label,
  color,
  info,
  onChange
}) {
  return /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    component: "fieldset",
    disabled: disabled,
    margin: "none",
    sx: {
      paddingRight: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    disableTypography: true,
    control: /*#__PURE__*/_react.default.createElement(_Switch2.default, {
      checked: value,
      color: "primary",
      onChange: (_, enabled) => onChange(enabled),
      value: value
    }),
    label: /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      gap: 2,
      height: 48
    }, icon || Icon ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      borderRadius: 16,
      display: "flex",
      height: 32,
      justifyContent: "center",
      sx: {
        backgroundColor: Icon && color ? (0, _styles.lighten)(color, 0.8) : color
      },
      width: 32
    }, Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
      sx: {
        color
      }
    }) : icon && /*#__PURE__*/_react.default.createElement("img", {
      src: icon,
      width: 20
    })) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
      width: 32
    }), /*#__PURE__*/_react.default.createElement(_Typography2.default, null, label), info && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
      placement: "right",
      slotProps: {
        popper: {
          sx: ({
            shadows
          }) => ({
            '> div': {
              backgroundColor: '#fff',
              boxShadow: shadows[1],
              color: 'rgba(0, 0, 0, 0.87)',
              padding: 2
            }
          })
        }
      },
      title: info
    }, /*#__PURE__*/_react.default.createElement(_InfoOutlined2.default, {
      color: "action",
      fontSize: "small"
    }))),
    labelPlacement: "start"
  }));
}
const StyledDrawer = (0, _styledComponents.styled)(_Drawer2.default)`
  width: ${`${layersDrawerWidth}px`};

  && > .MuiPaper-root {
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: ${`${layersDrawerWidth}px`};
  }

  &.full-width {
    width: 100%;

    && > .MuiPaper-root {
      width: 100%;
    }
  }
`;